import React, { useState } from 'react';
import axios from 'axios';
import { Box, Typography, Paper, TextField, Button, Alert, CircularProgress } from '@mui/material';

const ReportProblem = () => {
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!message.trim()) {
      setError('Inserisci un messaggio prima di inviare.');
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post('/api/support/report', { message: message.trim() });
      setSuccess(res.data?.message || 'Segnalazione inviata.');
      setMessage('');
    } catch (err) {
      setError(err.response?.data?.error || 'Errore durante l\'invio della segnalazione.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper sx={{ p: { xs: 2, sm: 3, md: 4 }, maxWidth: 640 }}>
      <Typography variant="h5" gutterBottom>Segnala un problema</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Descrivi il problema riscontrato. Riceveranno la segnalazione i super admin.
      </Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          label="Messaggio"
          multiline
          minRows={5}
          fullWidth
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required
        />
        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mt: 2 }}>{success}</Alert>}
        <Button type="submit" variant="contained" sx={{ mt: 3 }} disabled={loading}>
          {loading ? <CircularProgress size={24} /> : 'Invia segnalazione'}
        </Button>
      </Box>
    </Paper>
  );
};

export default ReportProblem;
